/**
 * FedEx 검수 ↔ AI 어시스턴트 컨텍스트 버스
 *
 * FedexVerifyPanel(현재 검수 중인 파일의 추출 JSON·OCR·규칙)와
 * App.js 전역 AI 어시스턴트 패널은 서로 다른 컴포넌트 트리에 있어
 * props 로 데이터를 전달할 수 없다. 이 모듈이 둘 사이의 단일 통로.
 *
 * - FedexVerifyPanel: 파일/페이지가 바뀔 때마다 setFedexCtx(...) 로 발행
 * - FedexAssistantPanel: subscribeFedexCtx(...) 로 구독해 현재 컨텍스트 사용
 */
let _ctx = null;
const _subs = new Set();

export function setFedexCtx(ctx) {
  _ctx = ctx;
  _subs.forEach((fn) => {
    try { fn(_ctx); } catch (_) { /* noop */ }
  });
}

export function getFedexCtx() {
  return _ctx;
}

export function subscribeFedexCtx(fn) {
  _subs.add(fn);
  return () => _subs.delete(fn);
}
